import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	asanaAssignee: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-assignee',
		defaultMessage: 'Assignee',
		description: 'Name of the Assignee field in an Asana Project',
	},
	asanaName: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-name',
		defaultMessage: 'Task name',
		description: 'Name of the Task name field in an Asana Project',
	},
	asanaSection: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-section',
		defaultMessage: 'Section',
		description: 'Name of the Section field in an Asana Project',
	},
	asanaDescription: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-description',
		defaultMessage: 'Description',
		description: 'Name of the Description field in an Asana Project',
	},
	asanaDueOn: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-due-on',
		defaultMessage: 'Due on',
		description: 'Name of the due on field in an Asana Project',
	},
	asanaStartDate: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-start-date',
		defaultMessage: 'Start date',
		description: 'Name of the start date field in an Asana Project',
	},
	asanaCollaborators: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-collaborators',
		defaultMessage: 'Collaborators',
		description: 'Name of the collaborators field in an Asana Project',
	},
	asanaLikes: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-likes',
		defaultMessage: 'Likes',
		description: 'Name of the likes field in an Asana Project',
	},
	asanaTags: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-tags',
		defaultMessage: 'Tags',
		description: 'Name of the tags field in an Asana Project',
	},
	asanaCreatedBy: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-created-by',
		defaultMessage: 'Created by',
		description: 'Name of the created by field in an Asana Project',
	},
});
